export default __webpack_public_path__ + "static/media/7s.43ac661e.png";